import React from 'react';
import Review from './review';
import '../css/Service.css';

function OtherWaste() {
  return (
    <div className="service-page">
      <div className="service-banner">
        <img src={'/img_8.jpg'} alt="Other Waste Banner" className="service-banner-img" />
        <div className="service-banner-overlay"></div>
        <div className="service-banner-content">
          <h1>Other Waste</h1>
        </div>
      </div>

      <header className="service-header">
        <h1>OTHER WASTE</h1>
        <p>
          We offer recycling and disposal solutions for a wide range of specialty waste and packaging streams.
        </p>
      </header>

      <section className="service-content">
        <div className="service-content-left">
          <h2>Specialty streams we manage include:</h2>
          <ol className="feature-list">
            <li>Paper and cardboard packaging</li>
            <li>Plastic packaging</li>
            <li>Wooden packaging</li>
            <li>Metallic packaging</li>
            <li>Composite & mixed packaging</li>
            <li>Glass packaging</li>
            <li>Textile packaging</li>
            <li>Concrete, bricks, tiles and ceramics</li>
            <li>Wood, treated and untreated</li>
            <li>Mixed metals (copper, bronze, brass, aluminum, lead, iron, steel, tin)</li>
            <li>Cables (with oil/coal/tar and other cables)</li>
            <li>Soils and dredging materials (including those with hazardous constituents)</li>
            <li>Insulation materials (including asbestos-containing where managed safely)</li>
            <li>Gypsum materials and unused/unset cement</li>
            <li>Paint and varnish remover residues</li>
          </ol>

          <p>
            Our team provides tailored handling, recycling pathways, or compliant disposal options depending on material type and regulatory status.
          </p>

          <div className="service-cta">
            <a href="/contact" className="btn btn-primary">Request Other Waste Services</a>
          </div>
        </div>

        <aside className="service-content-right">
          <div className="specialty-card">
            <h3>Service Highlights</h3>
            <ul className="specialty-list">
              <li>Material-specific recycling channels</li>
              <li>Secure transport and manifesting</li>
              <li>On-site characterization and separation</li>
              <li>Customized reuse and recovery programs</li>
            </ul>
          </div>
        </aside>
      </section>

      <Review />
    </div>
  );
}

export default OtherWaste;
